<template>
  <v-col style="max-width: 900px">
    <br />
    <h1 class="left-align">
      {{ $t('documentation.titles.services.title') }}
    </h1>
    <br />
    <h2 class="left-align">
      {{ $t('documentation.titles.services.subsections.renewal') }}
    </h2>

    <p class="left-align">
      {{ $t('documentation.texts.renewServices.paragraph1') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <br />
    <p class="left-align">
      {{ $t('documentation.texts.renewServices.paragraph2') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic2Name" />
    <br />
    <p class="left-align">
      {{ $t('documentation.texts.renewServices.paragraph3') }}
    </p>
    <br />
    <v-img style="width: 100%; max-width: 900px" contain :src="pic3Name" />
    <br />
    <p class="left-align">
      {{ $t('documentation.texts.renewServices.paragraph4') }}
    </p>
    <br />
    <v-img style="width: 100%; max-width: 900px" contain :src="pic4Name" />
    <br />
    <p class="left-align">
      {{ $t('documentation.texts.renewServices.paragraph5') }}
    </p>
    <br />
    <v-img style="width: 100%; max-width: 900px" contain :src="pic5Name" />

    <br />
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isAddaliaAdminUser']),
    pic1Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.renewServices.picRenewServicesMenu') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.renewServices.picNotRenewal') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.renewServices.picMarkToActivate') +
        '.png')
    },
    pic4Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.renewServices.picToActivateRenewal') +
        '.png')
    },
    pic5Name() {
      return require('@/assets/documentation/services/' +
        this.$t('documentation.texts.renewServices.picPurchaseActivated') +
        '.png')
    },
  },
  methods: {
    goDoc(section, subsection = '') {
      if (subsection === '') {
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section },
        })
      } else
        this.$router.push({
          name: 'DocumentationView',
          query: { section: section, subsection },
        })
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}

.custom-link:hover {
  text-decoration: underline;
}

.left-align {
  text-align: left;
}
</style>
